import type { MetricSeries } from "../hooks/useAdminStatus";
import type { ChartCardState } from "../components/admin/ChartCard";

export type MetricStatus = "loading" | "ready" | "error";

// Maps a fetch status + the resolved series to a ChartCard state. The
// load-bearing case is "empty": a series that exists but whose every point is
// null (no CloudWatch datapoints in the window) - that's the "collecting data"
// state, distinct from a genuine ready chart. Kept pure so it's unit-testable
// without a DOM (no jsdom in this repo).
export const metricCardState = (
  status: MetricStatus,
  series: MetricSeries | null | undefined,
): ChartCardState => {
  if (status === "loading") return "loading";
  if (status === "error") return "error";
  if (series == null) return "empty";
  const hasData = series.points.some((p) => p.value != null);
  return hasData ? "ready" : "empty";
};
